import { Helmet, HelmetProvider } from 'react-helmet-async';
import favicon from '../imagenes/logoutm.png'
import FiltrarVisitasDirectas from '../componentes/FiltrarVisitasDirectas';

const ConsultarVisitasDirectas = () => {
    return (
        <>
            <HelmetProvider>
                <div>
                    <Helmet>
                        <link rel="shortcut icon" href={favicon} type="image/x-icon"/>
                        <title>Consultar Visitas - Sistema de Administración Museo UTM</title>
                    </Helmet>
                </div>
            </HelmetProvider>

            <FiltrarVisitasDirectas />
        </>
    );
}

export default ConsultarVisitasDirectas; 